// Import Pages
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       action
 * @param       showAlert -  show alert
 * @param       setOpenVariable
 * @param       variables
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function AddParagraph({ action, showAlert, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const [fontType, setFontType] = useState([]);
    const [color, setColor] = useState([]);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    const label = 'CONTENT.CONFIGURATION-FORM.WORD.ADD-PARAGRAPH.';

    const fontTypeOptions = [
        { name: "Bold", value: "b" },
        { name: "Italic", value: "i" },
        { name: "Underline", value: "u" }
    ]

    useEffect(() => {
        if (!action.fields.fontType)
            action.fields.fontType = { value: [], type: 'ARRAY' };
        else
            setFontType(action.fields.fontType.value)

    }, [action])

    function handleFontType(value) {
        setFontType(value);
        const field = initialActionsData[action.id]?.fields.fontType;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("fontType", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);
        action.fields.fontType.value = value;
    }

    return (
        <div>
            <div className="conf-field-container">
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'WORD-SOURCE')} is_required />
                    <VariablePicker action={action} inputName="wordSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="array" isRequired hideRequired />
                    <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
                </div>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'PARAGRAPH-DATA')} is_required />
                <TextInput action={action} inputName="paragraphData" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired={true} multiline hideRequired />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "FONT-TYPE")} />
                <Autocomplete
                    multiple
                    id="tags-outlined"
                    options={fontTypeOptions}
                    getOptionLabel={(option) => option.name}
                    value={fontType}
                    getOptionSelected={(option, value) => option.name === value.name}
                    onChange={(event, value) => handleFontType(value)}
                    filterSelectedOptions
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            placeholder={t(label + "FONT-TYPE")}
                        />
                    )}
                />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'COLOR')} />
                <TextInput action={action} inputName="color" variables={variables}
                    setOpenVariable={setOpenVariable} />
                <small className="conf-field-desc"><em>{t(label + 'COLOR-HEX-COMMENT')}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'FONT-SIZE')} />
                <TextInput action={action} inputName="fontSize" variables={variables}
                    setOpenVariable={setOpenVariable} />
                <small className="conf-field-desc"><em>{t(label + 'FONT-SIZE-COMMENT')}</em></small>
            </div>
        </div>
    )
}

export default AddParagraph;
